export enum OrderPaymentStatus {
  WAITING = 'WAITING',
  AUTHORIZED = 'AUTHORIZED',
}
